{
  "title": "Notificaciones",
  "mark_all": "Marcar todas",
  "empty": "Sin notificaciones",
  "loading": "Cargando…",
  "view_all": "Ver todas",
  "page_subtitle": "Todas tus notificaciones en un solo lugar",
  "load_more": "Cargar más",
  "loading_more": "Cargando…",
  "empty_page_title": "No tienes notificaciones",
  "empty_page_subtitle": "Cuando te asignen tareas o comenten algo, aparecerán aquí.",
  "time": {
    "now": "ahora",
    "minutes_ago": "hace {n} min",
    "hours_ago": "hace {n} h",
    "days_ago": "hace {n} d"
  }
}
